// nuxt-ui/middleware/notFoundNations.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "kwc-nations") {
    throw createError({ statusCode: 404 });
  }
});
